import { loadOptions } from '../../versa/formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '0', label: 'Livre' },
			{ value: '1', label: 'Em uso' },
			{ value: '2', label: 'Entrada Bloqueada' },
			{ value: '3', label: 'Entrada Bloqueada' },
			{ value: '4', label: 'Saída Bloqueada' },
			{ value: '5', label: 'Saída Bloqueada' },
			{ value: '6', label: 'Toda Bloqueada' },
			{ value: '7', label: 'Toda Bloqueada' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

